import { render, staticRenderFns } from "./CustomerManagement.vue?vue&type=template&id=49d44fbc"
import script from "./CustomerManagement.vue?vue&type=script&lang=js"
export * from "./CustomerManagement.vue?vue&type=script&lang=js"
import style0 from "./CustomerManagement.vue?vue&type=style&index=0&id=49d44fbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports